import {
  Flex,
  Input,
  InputGroup,
  InputLeftAddon,
} from "@chakra-ui/react";
import Fieldset from "../../../general/form/Fieldset";
import FileUpload from "../../../general/form/FileUpload"; // Assuming you created a custom FileUpload component
import { Link } from "react-router-dom";

const OnboardingStep32 = ({ formData, handleFileChange }) => {
  return (
    <>
      {/* Required Documentation Section */}
      <Flex direction="column" gap={8}>
        <Flex direction="column" gap={2}>
          <h6>Required documentation</h6>
          <p>
            Please upload the required documents for the fund. You can manage
            the required documents by fund type in the{" "}
            <Link style={{ color: "brand.100" }}>settings</Link>.
          </p>
        </Flex>
        <Flex direction="column">
          {/* Fund Documentation */}

          <Fieldset
            direction="column"
            label="Fund documentation"
            input={
              <Flex direction={{ lg: "row", base: "column" }} gap={4} flex={1}>
                <Flex direction={"column"} gap={2} flex={1}>
                  <FileUpload
                    label="Offering memorandum"
                    name="offeringMemorandum"
                    placeholder="Choose file"
                    value={formData.offeringMemorandum || ""}
                    onChange={(file) =>
                      handleFileChange(file, "offeringMemorandum")
                    }
                    accept=".pdf,.doc,.docx"
                  />
                  <InputGroup>
                    <InputLeftAddon
                      fontSize={"12px"}
                      color={"grey.700"}
                      fontWeight={"600"}>
                      Exp. date
                    </InputLeftAddon>
                    <Input
                      type="date"
                      disabled={!formData.offeringMemorandum}
                    />
                  </InputGroup>
                </Flex>

                <Flex direction={"column"} gap={2} flex={1}>
                  <FileUpload
                    label="Articles / LPA"
                    name="articlesLPA"
                    placeholder="Choose file"
                    value={formData.articlesLPA || ""}
                    onChange={(file) => handleFileChange(file, "articlesLPA")}
                    accept=".pdf,.doc,.docx"
                  />
                  <InputGroup>
                    <InputLeftAddon
                      fontSize={"12px"}
                      color={"grey.700"}
                      fontWeight={"600"}>
                      Exp. date
                    </InputLeftAddon>
                    <Input type="date" disabled={!formData.articlesLPA} />
                  </InputGroup>
                </Flex>

                <Flex direction={"column"} gap={2} flex={1}>
                  <FileUpload
                    label="Subscription documents"
                    name="subscriptionDocuments"
                    placeholder="Choose file"
                    value={formData.subscriptionDocuments || ""}
                    onChange={(file) =>
                      handleFileChange(file, "subscriptionDocuments")
                    }
                    accept=".pdf,.doc,.docx"
                  />
                  <InputGroup>
                    <InputLeftAddon
                      fontSize={"12px"}
                      color={"grey.700"}
                      fontWeight={"600"}>
                      Exp. date
                    </InputLeftAddon>
                    <Input
                      type="date"
                      disabled={!formData.subscriptionDocuments}
                    />
                  </InputGroup>
                </Flex>
              </Flex>
            }
          />

          {/* Governance Documents */}
          <Fieldset
            label="Governance documents"
            direction="column"
            input={
              <Flex direction={{ lg: "row", base: "column" }} gap={4} flex={1}>
                <Flex direction={"column"} gap={2} flex={1}>
                  <FileUpload
                    label="Structure chart"
                    name="structureChart"
                    placeholder="Choose file"
                    value={formData.structureChart || ""}
                    onChange={(file) =>
                      handleFileChange(file, "structureChart")
                    }
                    accept=".pdf,.doc,.docx"
                  />
                  <InputGroup>
                    <InputLeftAddon
                      fontSize={"12px"}
                      color={"grey.700"}
                      fontWeight={"600"}>
                      Exp. date
                    </InputLeftAddon>
                    <Input type="date" disabled={!formData.structureChart} />
                  </InputGroup>
                </Flex>

                <Flex direction={"column"} gap={2} flex={1}>
                  <FileUpload
                    label="Board members ID & CV"
                    name="boardMembersID"
                    placeholder="Choose file"
                    value={formData.boardMembersID || ""}
                    onChange={(file) =>
                      handleFileChange(file, "boardMembersID")
                    }
                    accept=".pdf,.doc,.docx"
                  />
                  <InputGroup>
                    <InputLeftAddon
                      fontSize={"12px"}
                      color={"grey.700"}
                      fontWeight={"600"}>
                      Exp. date
                    </InputLeftAddon>
                    <Input type="date" disabled={!formData.boardMembersID} />
                  </InputGroup>
                </Flex>

                <Flex direction={"column"} gap={2} flex={1}>
                  <FileUpload
                    label="UBO declaration"
                    name="uboDeclaration"
                    placeholder="Choose file"
                    value={formData.uboDeclaration || ""}
                    onChange={(file) =>
                      handleFileChange(file, "uboDeclaration")
                    }
                    accept=".pdf,.doc,.docx"
                  />
                  <InputGroup>
                    <InputLeftAddon
                      fontSize={"12px"}
                      color={"grey.700"}
                      fontWeight={"600"}>
                      Exp. date
                    </InputLeftAddon>
                    <Input type="date" disabled={!formData.uboDeclaration} />
                  </InputGroup>
                </Flex>
              </Flex>
            }
          />

          {/* Service Agreements */}
          <Fieldset
            label="Service agreements"
            direction="column"
            input={
              <Flex direction={{ lg: "row", base: "column" }} gap={4} flex={1}>
                <Flex direction={"column"} gap={2} flex={1}>
                  <FileUpload
                    label="Depositary agreement"
                    name="depositaryAgreement"
                    placeholder="Choose file"
                    value={formData.depositaryAgreement || ""}
                    onChange={(file) =>
                      handleFileChange(file, "depositaryAgreement")
                    }
                    accept=".pdf,.doc,.docx"
                  />
                  <InputGroup>
                    <InputLeftAddon
                      fontSize={"12px"}
                      color={"grey.700"}
                      fontWeight={"600"}>
                      Exp. date
                    </InputLeftAddon>
                    <Input
                      type="date"
                      disabled={!formData.depositaryAgreement}
                    />
                  </InputGroup>
                </Flex>

                <Flex direction={"column"} gap={2} flex={1}>
                  <FileUpload
                    label="Administration agreement"
                    name="administrationAgreement"
                    placeholder="Choose file"
                    value={formData.administrationAgreement || ""}
                    onChange={(file) =>
                      handleFileChange(file, "administrationAgreement")
                    }
                    accept=".pdf,.doc,.docx"
                  />
                  <InputGroup>
                    <InputLeftAddon
                      fontSize={"12px"}
                      color={"grey.700"}
                      fontWeight={"600"}>
                      Exp. date
                    </InputLeftAddon>
                    <Input
                      type="date"
                      disabled={!formData.administrationAgreement}
                    />
                  </InputGroup>
                </Flex>

                <Flex direction={"column"} gap={2} flex={1}>
                  <FileUpload
                    label="AIFM agreement"
                    name="aifmAgreement"
                    placeholder="Choose file"
                    value={formData.aifmAgreement || ""}
                    onChange={(file) => handleFileChange(file, "aifmAgreement")}
                    accept=".pdf,.doc,.docx"
                  />
                  <InputGroup>
                    <InputLeftAddon
                      fontSize={"12px"}
                      color={"grey.700"}
                      fontWeight={"600"}>
                      Exp. date
                    </InputLeftAddon>
                    <Input type="date" disabled={!formData.aifmAgreement} />
                  </InputGroup>
                </Flex>
              </Flex>
            }
          />

          {/* Investment Documentation */}
          <Fieldset
            label="Investment documentation"
            direction="column"
            input={
              <Flex direction={{ lg: "row", base: "column" }} gap={4} flex={1}>
                <Flex direction={"column"} gap={2} flex={1}>
                  <FileUpload
                    label="Investment strategy"
                    name="investmentStrategy"
                    placeholder="Choose file"
                    value={formData.investmentStrategy || ""}
                    onChange={(file) =>
                      handleFileChange(file, "investmentStrategy")
                    }
                    accept=".pdf,.doc,.docx"
                  />
                  <InputGroup>
                    <InputLeftAddon
                      fontSize={"12px"}
                      color={"grey.700"}
                      fontWeight={"600"}>
                      Exp. date
                    </InputLeftAddon>
                    <Input
                      type="date"
                      disabled={!formData.investmentStrategy}
                    />
                  </InputGroup>
                </Flex>

                <Flex direction={"column"} gap={2} flex={1}>
                  <FileUpload
                    label="Risk management policy"
                    name="riskManagementPolicy"
                    placeholder="Choose file"
                    value={formData.riskManagementPolicy || ""}
                    onChange={(file) =>
                      handleFileChange(file, "riskManagementPolicy")
                    }
                    accept=".pdf,.doc,.docx"
                  />
                  <InputGroup>
                    <InputLeftAddon
                      fontSize={"12px"}
                      color={"grey.700"}
                      fontWeight={"600"}>
                      Exp. date
                    </InputLeftAddon>
                    <Input
                      type="date"
                      disabled={!formData.riskManagementPolicy}
                    />
                  </InputGroup>
                </Flex>

                <Flex direction={"column"} gap={2} flex={1}>
                  <FileUpload
                    label="Valuation policy"
                    name="valuationPolicy"
                    placeholder="Choose file"
                    value={formData.valuationPolicy || ""}
                    onChange={(file) =>
                      handleFileChange(file, "valuationPolicy")
                    }
                    accept=".pdf,.doc,.docx"
                  />
                  <InputGroup>
                    <InputLeftAddon
                      fontSize={"12px"}
                      color={"grey.700"}
                      fontWeight={"600"}>
                      Exp. date
                    </InputLeftAddon>
                    <Input type="date" disabled={!formData.valuationPolicy} />
                  </InputGroup>
                </Flex>
              </Flex>
            }
          />
        </Flex>
      </Flex>
    </>
  );
};

export default OnboardingStep32;
